import { render } from "./cnt-table_milestones_mfa.vue?vue&type=template&id=b6c24722&scoped=true"
const script = {}

import "./cnt-table_milestones_mfa.vue?vue&type=style&index=0&id=b6c24722&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c24722"]])

export default __exports__